import React from "react";
import { notify } from "@/shared/utils/notify";
import { rulesApplyFiftyPercentDiscount } from "../../../shared/services";
import { IRulesSushiLunch } from "../../../redux/@types";

export const useRulesSushiLunch = ({
  rule_id,
}: {
  rule_id: number;
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [comboRuleById, setComboRuleById] = React.useState<IRulesSushiLunch>();
  
  const getComboRuleById = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await rulesApplyFiftyPercentDiscount.get(rule_id);
      setComboRuleById(res);
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    getComboRuleById();
  }, [rule_id]);

  return {
    loading,
    comboRuleById,
    getComboRuleById,
    // selectedDays,
  };
};
